import React from 'react';
import NvIcon from 'shared/components/nv-icon';


type Props = {
  className?: string,
  style?: React.CSSProperties,
};

const LockedOverlay = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    style,
    className,
  } = props;

  return (
    <div
      ref={ref}
      style={style}
      className={`d-flex align-items-center justify-content-center ${className ? `${className}` : ''}`}
    >
      <NvIcon
        size='small'
        icon='locked'
        className='color-white'
      />
    </div>
  );
});

export default LockedOverlay;
